import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sanBernardinoConfig } from "./data";

export default function SanBernardinoPage() {
  return <CityPageTemplate config={sanBernardinoConfig} />;
}